import { RecommendedCompsStatistics, noop } from '@aloft/toolkit-shared';
import { Button, Flex, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { Skeleton } from '@aloft/toolkit-sui/chakra';

type SaleStatChipProps = {
  label: string;
  value?: number;
  isLoading: boolean;
};

const SaleStatChip = ({ label, value, isLoading }: SaleStatChipProps) => (
  <Flex alignItems="center" gap="4px">
    <Typography variant="body2" color="textSecondary">
      {label}
    </Typography>
    {isLoading || value === undefined ? (
      <Skeleton height="12px" width="24px" borderRadius="2px" />
    ) : (
      <Typography variant="body2" color="textPrimary">
        {value}
      </Typography>
    )}
  </Flex>
);

type RecommendedCompsModalHeaderProps = {
  statistics?: RecommendedCompsStatistics;
  isLoading: boolean;
  onExportCSV: () => void;
};

export const RecommendedCompsModalHeader = ({
  statistics,
  isLoading,
  onExportCSV,
}: RecommendedCompsModalHeaderProps) => (
  <Flex alignItems="center" justifyContent="space-between" flex={1} paddingRight="40px">
    <Flex alignItems="center" gap="32px">
      <Typography variant="h2">Recommended Comps</Typography>
      <Flex alignItems="center" gap="16px">
        <Typography variant="body2" color="textPrimary">
          Sales in the last:
        </Typography>
        <SaleStatChip
          label="0-3 months:"
          value={statistics?.last3MonthsListingsCount}
          isLoading={isLoading}
        />
        <SaleStatChip
          label="4-6 months:"
          value={statistics?.last6MonthsListingsCount}
          isLoading={isLoading}
        />
        <SaleStatChip
          label="7-12 months:"
          value={statistics?.last12MonthsListingsCount}
          isLoading={isLoading}
        />
      </Flex>
    </Flex>

    <Flex alignItems="center" gap="16px">
      <Button
        icon="download"
        size="sm"
        variant="secondary"
        text="Export to CSV"
        onClick={onExportCSV}
      />
      <Button
        icon="settings-3"
        size="sm"
        variant="secondary"
        text="Settings"
        disabled // TODO: update this when the column settings modal is implemented
        onClick={noop}
      />
    </Flex>
  </Flex>
);
